//@flow
import React, { Component, type Element as ReactElement } from 'react';
import { SpacerTab, TabA } from '../../../components/TabStyles';
import { ToggleTabs } from './TableComponentStyles';
import { SmMobile, SmDefault } from '../../../components/Responsive';

type Props = {
  data: {
    sectionValue1: string,
    sectionValue2: string,
    handleClick: string => void,
    activeSection: string,
    noFlex?: boolean,
    RightAction?: ReactElement<any>
  }
};

type State = {
  activeSection: string
};

export default class TableToggle extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      activeSection: props.data.activeSection
    };
  }
  static defaultProps = {
    noFlex: true
  };

  truncateString = (sectionValue: string) => {
    const wordsArr = sectionValue.split(' ');
    if (wordsArr.length > 1) {
      return (
        <>
          <SmMobile>{wordsArr[1]}</SmMobile>
          <SmDefault>{sectionValue}</SmDefault>
        </>
      );
    } else {
      return sectionValue;
    }
  };

  render() {
    return (
      <ToggleTabs activeSection={this.props.data.activeSection}>
        <TabA
          onClick={() =>
            this.props.data.handleClick(this.props.data.sectionValue1)
          }
          className={
            this.props.data.activeSection === this.props.data.sectionValue1
              ? 'active'
              : ''
          }
          noFlex={this.props.data.noFlex}
        >
          {this.truncateString(this.props.data.sectionValue1)}
        </TabA>
        <TabA
          onClick={() =>
            this.props.data.handleClick(this.props.data.sectionValue2)
          }
          className={
            this.props.data.activeSection === this.props.data.sectionValue2
              ? 'active'
              : ''
          }
          noFlex={this.props.data.noFlex}
        >
          {this.truncateString(this.props.data.sectionValue2)}
        </TabA>
        <SpacerTab tablet />
        {this.props.data.RightAction}
      </ToggleTabs>
    );
  }
}
